import { render, staticRenderFns } from "./KarenAIFilesManager.vue?vue&type=template&id=603e5a1d&scoped=true&"
import script from "./KarenAIFilesManager.vue?vue&type=script&lang=js&"
export * from "./KarenAIFilesManager.vue?vue&type=script&lang=js&"
import style0 from "./KarenAIFilesManager.vue?vue&type=style&index=0&id=603e5a1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603e5a1d",
  null
  
)

export default component.exports